<template>
    <div style="text-align: left;">
        <Scroll :height="height - 80">
            <Spin fix v-show="isRechargeInfo || isRecentRechargeRecord || isDeviceStatusRecent || isLadderPriceRecent || isExceptionRecent || isCommitSpin">
                <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Tabs ref="tabs" v-if="rechargeBaseInfo">
                <TabPane label="充值" icon="logo-bitcoin" style="font-size:12pt">
                    <Row style="background:#fff;padding:10px">
                        <Col span="24">
                        <Card>
                            <p slot="title">
                                <Icon type="ios-contact" size="21" />
                                用户信息</p>
                            <Row>
                                <Col span="24">
                                用户姓名 : {{rechargeBaseInfo.customerName}}
                                </Col>
                                <Row>
                                </Row>
                                <Col span="24">
                                手机号 : {{rechargeBaseInfo.customerPhone}}
                                </Col>
                            </Row>
                            <Row>
                                <Col span="24">
                                身份证号 : {{rechargeBaseInfo.customerIdcard}}
                                </Col>
                            </Row>
                            <Row>
                                <Col span="24">
                                地址 : {{rechargeBaseInfo.addressLowestLevelAddressIds}}
                                </Col>
                            </Row>
                        </Card>
                        </Col>

                        <Col span="24" style="padding:20px 0px 0px 0px;">
                        <Row>
                            <Card>
                                <p slot="title">
                                    <Icon type="ios-pulse" size="20" />
                                    设备状态</p>
                                {{deviceStatusPresent}}
                            </Card>
                        </Row>
                        <Row style="padding:20px 0px 0px 0px;">
                            <Card>
                                <p slot="title">
                                    <Icon type="md-close-circle" size="20" />
                                    报警信息</p>
                                {{exceptionPresent}}
                            </Card>
                        </Row>
                        </Col>
                    </Row>
                    <Row style="background:#fff;padding:10px">
                        <Col span="24">
                        <Card v-if="isFlow">
                            <p slot="title">
                                <Icon type="logo-yen" size="16" />
                                充值信息</p>
                            <Row>
                                <Col span="24">
                                <Row>
                                    <Col span="11" style="text-align: right;">
                                    工况流量 ：
                                    </Col>
                                    <Col span="8" style="text-align: center;">
                                    <InputNumber v-model="workingFlowRecharge" :max="10000" :min="0" :step="1" size="small"
                                        :precision="0" @on-change="onWorkingFlowRechargeChange">
                                    </InputNumber>
                                    </Col>
                                    <Col span="4">
                                    m<sup>3</sup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col span="11" style="text-align: right;">
                                    缴费金额 ：
                                    </Col>
                                    <Col span="8" style="text-align: center;">
                                    {{workingFlowRechargeMoney}}
                                    </Col>
                                    <Col span="4">
                                    元
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span="11" style="text-align: right;">
                                    当前气价 ：
                                    </Col>
                                    <Col span="8" style="text-align: center;">
                                    {{workingFlowRankPricePresent}}
                                    </Col>
                                    <Col span="4">
                                    元
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span="11" style="text-align: right;">
                                    当前阶梯剩余气量 ：
                                    </Col>
                                    <Col span="8" style="text-align: center;">
                                    {{workingFlowRankRemain}}
                                    </Col>
                                    <Col span="4">
                                    m<sup>3</sup>
                                    </Col>
                                </Row>
                                </Col>
                            </Row>
                        </Card>
                        <Card v-if="!isFlow">
                            <p slot="title">
                                <Icon type="logo-yen" size="16" />
                                充值信息</p>
                            <Row>
                                <Col span="23">
                                <Row>
                                    <Col span="8" style="text-align: right;">
                                    工况金额 ：
                                    </Col>
                                    <Col span="8" style="text-align: center;">
                                    <InputNumber v-model="workingMoneyRecharge" :max="10000" :min="0" :step="1" size="small"
                                        :precision="0">
                                    </InputNumber>
                                    </Col>
                                    <Col span="4">
                                    元</sup>
                                    </Col>
                                </Row>
                                </Col>
                            </Row>
                        </Card>
                        </Col>
                        <Col span="24" style="padding:20px 0px 0px 0px;">
                        <Card>
                            <p slot="title">
                                <Icon type="md-trending-up" size="25" />
                                阶梯气价</p>
                            <Span v-if="isMainOverDue && !isStandbyOverDue" style="color: #FF0000;">当前使用备用阶梯</Span>
                            <Span v-if="Object.keys(ladderPriceRecent.paras) == 0">当前未设置阶梯气价或者阶梯气价超期</Span>
                            <Span v-if="Object.keys(ladderPriceRecent.paras) != 0" v-for="index in [1,2,3,4,5,6]">
                                第{{index}}阶梯{{ladderPriceRecent.paras["mainPlanLadder" + index + "Flow"]}}立方米，价格{{ladderPriceRecent.paras["mainPlanLadder" + index + "Price"] / 100}}元/m
                                <sup>3</sup>
                                <br>
                            </Span>
                        </Card>
                        </Col>
                    </Row>
                    <Button type="primary" size="large" :loading="isButtonLoading" long @click="commitRecharge">充值</Button>
                </TabPane>
                <TabPane label="充值历史" icon="md-albums">
                    <Table :width="width" border stripe highlight-row ref="currentRowTable" :columns="columnsRechargeRecord"
                        :data="dataRechargeRecord"></Table>
                    <Page :current="page" :total="dataCount" :page-size="pageAmount" show-sizer show-total @on-change="changePage"
                        @on-page-size-change="changePageSize"></Page>
                </TabPane>
            </Tabs>
            <div style="height:50px">
            </div>
        </Scroll>
    </div>
</template>

<script>
    export default {
        mounted() {

        },
        data() {
            return {
                isCommitSpin: false,
                dataForDown: [],
                modalLadderPrice: false,
                isRechargeInfo: false,
                isRecentRechargeRecord: false,
                isDeviceStatusRecent: false,
                isExceptionRecent: false,
                isLadderPriceRecent: false,
                height: window.innerHeight,
                width: window.innerWidth,
                deviceTemp: {},
                rechargeBaseInfo: {},
                ladderPrice: [],
                infoLadderPrice: {},
                isTrueLadderPrice: true,
                ladderPriceFlow: [],
                ladderPriceMoney: [],
                isFlow: true,
                isButtonLoading: false,
                workingFlowRecharge: 0, //工况流量
                workingFlowRechargeMoney: 0.0, //工况流量缴费金额
                workingFlowRankPricePresent: 0.0, //工况流量当前气价
                workingFlowRankRemain: 0.0, //工况流量当前阶梯剩余气量
                deviceStatusCommand: {}, //设备状态命令
                exceptionCommand: {}, //报警信息命令
                ladderPriceCommand: {}, //阶梯气价指令
                ladderPriceRecent: {
                    paras: {}
                }, //最近阶梯气价
                deviceStatus: {}, //设备状态参数
                deviceStatusPresent: "", //设备状态显示
                exceptionPresent: "",
                doRechargeData: {}, //下发充值数据
                totalRecordFlow: 0.0, //历史充值合计流量
                totalRecordMoney: 0.0, //历史充值合计钱
                workingMoneyRecharge: 0, //工况金额
                columnsRechargeRecord: [{
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '用户',
                        width: 150,
                        key: 'recordRechargeCustomerName'
                    },
                    {
                        title: '缴费金额（元）',
                        width: 150,
                        key: 'recordRechargePrice'
                    },
                    {
                        title: '充值气量（m³）',
                        width: 150,
                        key: 'recordRechargeFlow'
                    },
                    {
                        title: '缴费时间',
                        width: 150,
                        key: 'recordRechargeDate',
                        render: function(h, params) {
                            return h('div',
                                global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.row.recordRechargeDate))
                            ); /*这里的this.row能够获取当前行的数据*/
                        }
                    },
                    {
                        title: "主阶梯气价",
                        key: "mainPlan",
                        width: 150,
                        tooltip: true
                    },
                    {
                        title: "备用阶梯气价",
                        key: "standbyPlan",
                        width: 150,
                        tooltip: true
                    },
                    {
                        title: '营业员',
                        width: 150,
                        key: 'recordRechargePersonnelName'
                    }
                ],
                dataRechargeRecord: [],
                page: 1,
                pageAmount: 10,
                dataCount: 0,
                price: 1,
                recentFlowPrice: {},
                isMainOverDue: false,
                isStandbyOverDue: false,
                meterId: "",
                appId: "",
                timeStamp: "",
                nonceStr: "",
                _package: "",
                signType: "",
                signature: ""
            };
        },
        methods: {
            setMeter(meterId) {
                this.meterId = meterId;
                this.getRechargeBaseInfo(meterId);
                this.getRecordPage(meterId);
            },
            overDue() {
                let that = this;
                if (new Date().getTime() < new Date().getTime(that.ladderPriceRecent.paras.mainPlanStartTime) ||
                    new Date().getTime(that.ladderPriceRecent.paras.mainPlanEndTime) < new Date().getTime()
                ) {
                    that.isMainOverDue = true;
                    if (new Date().getTime() < new Date().getTime(that.ladderPriceRecent.paras.standbyPlanStartTime) ||
                        new Date().getTime(that.ladderPriceRecent.paras.standbyPlanEndTime) < new Date().getTime()
                    ) {
                        that.isStandbyOverDue = true;
                        that.ladderPriceRecent = {
                            paras: {}
                        };
                    } else {
                        that.ladderPriceRecent.paras.mainPlanStartTime = that.ladderPriceRecent.paras.standbyPlanStartTime;
                        that.ladderPriceRecent.paras.mainPlanEndTime = that.ladderPriceRecent.paras.standbyPlanEndTime;
                        that.ladderPriceRecent.paras.mainPlanSettleType = that.ladderPriceRecent.paras.standbyPlanSettleType;
                        that.ladderPriceRecent.paras.mainPlanSettleParameter = that.ladderPriceRecent.paras.standbyPlanSettleParameter;
                        for (let i = 1; i <= 6; i++) {
                            that.ladderPriceRecent.paras["mainPlanLadder" + i + "Flow"] = that.ladderPriceRecent.paras[
                                "standbyPlanLadder" + i + "Flow"];
                            that.ladderPriceRecent.paras["mainPlanLadder" + i + "Price"] = that.ladderPriceRecent.paras[
                                "standbyPlanLadder" + i + "Price"];
                        }
                    }
                }
            },
            getRechargeBaseInfo(param) {
                var that = this;
                this.deviceTemp["meterId"] = param;
                that.isRechargeInfo = true;
                that.workingFlowRecharge = 0; //工况流量
                that.workingFlowRechargeMoney = 0.0; //工况流量缴费金额
                that.workingMoneyRecharge = 0; //工况金额
                that.workingFlowRankPricePresent = 0;
                that.rechargeBaseInfo = {};
                that.ladderPriceRecent = {
                    paras: {}
                };
                //请求设备基础数据
                $.ajax({
                    url: "/api/recharge/getRechargeBaseInfo",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(
                        that.deviceTemp
                    ),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                        }
                        that.rechargeBaseInfo = data.body;
                        if(data.body.command){
                            that.ladderPriceRecent = JSON.parse(data.body.command.commandContent) 
                        }else{
                            that.ladderPriceRecent = {
                                paras: {}
                            };
                        }
                        that.overDue();
                        if (data.body.meterTypePayType.indexOf("流量") != -1) {
                            that.isFlow = true;
                            if (!that.isStandbyOverDue && data.body.command) {
                                var recordRecent = {};
                                recordRecent["recordRechargeMeterId"] = that.rechargeBaseInfo.meterId;
                                console.log(that.ladderPriceRecent.paras);
                                if (that.ladderPriceRecent.paras.mainPlanSettleType == 0 ||
                                    that.ladderPriceRecent.paras.mainPlanSettleType == 4) {
                                    recordRecent["recordRechargeDateMin"] = new Date(that.ladderPriceRecent.paras
                                        .mainPlanStartTime).getTime();
                                } else {
                                    let days = 0;
                                    if (that.ladderPriceRecent.paras.mainPlanSettleType == 1) {
                                        days = 30;
                                    } else if (that.ladderPriceRecent.paras.mainPlanSettleType == 2) {
                                        days = 90;
                                    } else if (that.ladderPriceRecent.paras.mainPlanSettleType == 3) {
                                        days = 365;
                                    } else if (that.ladderPriceRecent.paras.mainPlanSettleType == 5) {
                                        days = that.ladderPriceRecent.paras.mainPlanSettleParameter;
                                    }
                                    let count = (new Date().getTime() - new Date().getTime(that.ladderPriceRecent.paras
                                        .mainPlanStartTime)) / (days * 24 * 60 * 60 * 1000);
                                    count = count >> 0;
                                    recordRecent["recordRechargeDateMin"] = new Date(that.ladderPriceRecent.paras
                                        .mainPlanStartTime).getTime() + count * (days * 24 * 60 * 60 * 1000);
                                }
                                if(data.body.command.commandTimestamp > recordRecent["recordRechargeDateMin"]){
                                    recordRecent["recordRechargeDateMin"] = data.body.command.commandTimestamp;
                                }
                                that.isRecentRechargeRecord = true;
                                //获得上次充值信息
                                $.ajax({
                                    url: "/api/recharge/getRecentRechargeRecord",
                                    contentType: "application/json",
                                    type: "post",
                                    data: JSON.stringify(
                                        recordRecent
                                    ),
                                    dataType: "json",
                                    success: function(data) {
                                        if (data.errorCode != 0) {
                                            that.$Notice.error({
                                                title: "异常",
                                                desc: data.errorInfo
                                            });
                                            that.isRecentRechargeRecord = false;
                                            return;
                                        }
                                        if (data.body != null) {
                                            that.workingFlowRankPricePresent = data.body.recordRechargePresentLadderPrice;
                                            that.workingFlowRankRemain = data.body.recordRechargePresentLadderFlowRemain;
                                            that.totalRecordFlow = data.body.totalFlow;
                                            that.totalRecordMoney = data.body.totalMoney;
                                        } else {
                                            that.workingFlowRankPricePresent = 0;
                                            that.workingFlowRankRemain = 0;
                                            that.totalRecordFlow = 0;
                                            that.totalRecordMoney = 0;
                                        }
                                        that.isRecentRechargeRecord = false;
                                    },
                                    error: function(textStatus) {
                                        that.$Notice.error({
                                            title: "异常",
                                            desc: "接口请求异常"
                                        });
                                    }
                                });
                            }
                        } else if (data.body.meterTypePayType.indexOf("金额") != -1) {
                            that.isFlow = false;
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isRechargeInfo = false;
                    }
                });
                //请求设备状态
                this.deviceStatusCommand["commandType"] = "0x83";
                this.deviceStatusCommand["commandDeviceId"] = param;
                that.isDeviceStatusRecent = true;
                $.ajax({
                    url: "/api/instructions/getInstructionRecent",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(
                        that.deviceStatusCommand
                    ),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            that.isDeviceStatusRecent = false;
                            return;
                        }
                        //处理设备状态
                        if (data.body != null) {
                            that.deviceStatus = JSON.parse(data.body.commandContent);
                            if (that.deviceStatus.service.data.isValveBan == "true" && that.deviceStatus.service
                                .data.isValveClosed == "true") {
                                that.deviceStatusPresent = "表阀禁用/表阀关闭";
                            } else if (that.deviceStatus.service.data.isValveBan == "true" && that.deviceStatus
                                .service.data.isValveClosed == "false") {
                                that.deviceStatusPresent = "表阀禁用";
                            } else if (that.deviceStatus.service.data.isValveBan == "false" && that.deviceStatus
                                .service.data.isValveClosed == "true") {
                                that.deviceStatusPresent = "表阀关闭";
                            } else if (that.deviceStatus.service.data.isValveBan == "false" && that.deviceStatus
                                .service.data.isValveClosed == "false") {
                                that.deviceStatusPresent = "表阀正常";
                            }
                        } else {
                            that.deviceStatusPresent = "表阀正常";
                        }
                        that.isDeviceStatusRecent = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
                //请求报警信息
                this.exceptionCommand["commandType"] = "0x81";
                this.exceptionCommand["commandDeviceId"] = param;
                that.isExceptionRecent = true;
                $.ajax({
                    url: "/api/instructions/getInstructionRecent",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(
                        that.exceptionCommand
                    ),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            that.isExceptionRecent = false;
                            return;
                        }
                        //处理报警信息
                        if (data.body != null) {
                            let exception = JSON.parse(data.body.commandContent);
                            let exceptionNumber2 = parseInt(exception.service.data.errorFlags).toString(2); //十进制报警字段转2进制
                            let exceptions = (Array(32).join('0') + exceptionNumber2).slice(-32); //2进制补零
                            let exceptionList = exceptions.split(''); //2进制数组
                            exceptionList.reverse().forEach((item, index) => {
                                if (global.errorMsgParam[index] && item == 1) {
                                    that.exceptionPresent = that.exceptionPresent == '' ?
                                        global.errorMsgParam[index].name : that.exceptionPresent +
                                        ',' + global.errorMsgParam[index].name;
                                }
                            });
                            if (that.exceptionPresent == '') {
                                that.exceptionPresent = '表具正常';
                            }
                        } else {
                            that.exceptionPresent = "无报警信息";
                        }
                        that.isExceptionRecent = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            changePage(index) {
                this.page = index;
                this.getRecordPage(this.deviceTemp.meterId);
            },
            changePageSize(size) {
                this.pageAmount = size;
                this.getRecordPage(this.deviceTemp.meterId);
            },
            getRecordPage(param) {
                var that = this;
                var recordModel = {};
                recordModel["recordRechargeMeterId"] = param;
                //请求设备基础数据
                $.ajax({
                    url: "/api/recharge/getRechargeRecordList?page=" + this.page + "&pageAmount=" + this.pageAmount,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(
                        recordModel
                    ),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.dataRechargeRecord = data.body.resultList.map(param => {
                            param["ladderData"] = JSON.parse(param.recordRechargeLadderPriceCopy).paras;
                            let mainPlan = "";
                            mainPlan += "开始时间：" + global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(
                                param.ladderData.mainPlanStartTime)) + "\n";
                            mainPlan += "结束时间：" + global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(
                                param.ladderData.mainPlanEndTime)) + "\n";
                            mainPlan += "结算类型：" + global.ladderPriceSettleType[param.ladderData.mainPlanSettleType];
                            if (param.ladderData.mainPlanSettleType != 0 && param.ladderData.mainPlanSettleType != 4) {
                                mainPlan += "\n结算周期：" + param.ladderData.mainPlanSettleParameter;
                            }
                            for (var i = 1; i <= 6; i++) {
                                mainPlan += "\n" + "第" + i + "阶梯共" + param.ladderData[
                                    "mainPlanLadder" + i +
                                    "Flow"] + "m³,价格:" + param.ladderData["mainPlanLadder" + i +
                                    "Price"] / 100 + "元/m³";
                            }
                            param["mainPlan"] = mainPlan;
                            let standbyPlan = "";
                            standbyPlan += "开始时间：" + global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(
                                param.ladderData.standbyPlanStartTime)) + "\n";
                            standbyPlan += "结束时间：" + global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(
                                param.ladderData.standbyPlanEndTime)) + "\n";
                            standbyPlan += "结算类型：" + global.ladderPriceSettleType[param.ladderData.standbyPlanSettleType];
                            if (param.ladderData.standbyPlanSettleType != 0 && param.ladderData.standbyPlanSettleType != 4) {
                                standbyPlan += "\n结算周期：" + param.ladderData.standbyPlanSettleParameter;
                            }
                            for (var i = 1; i <= 6; i++) {
                                standbyPlan += "\n" + "第" + i + "阶梯共" + param.ladderData[
                                    "standbyPlanLadder" + i +
                                    "Flow"] + "m³,价格:" + param.ladderData["standbyPlanLadder" +
                                    i +
                                    "Price"] / 100 + "元/m³";
                            }
                            param["standbyPlan"] = standbyPlan;
                            return param;
                        });
                        that.dataCount = data.body.amount;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });

            },
            onWorkingFlowRechargeChange(param) {
                let totalRecordFlowParam = this.totalRecordFlow;
                let totalRecordMoneyParam = this.totalRecordMoney;
                param = param + totalRecordFlowParam;
                var rank = 5;
                var rankFlow = 0;
                var index = 1;
                while (index < 10) {
                    rankFlow += this.ladderPriceRecent.paras["mainPlanLadder" + index + "Flow"];
                    if (param <= rankFlow) {
                        break;
                    }
                    index++;
                }
                if (Object.keys(this.ladderPriceRecent.paras) != 0) {
                    this.workingFlowRechargeMoney = (this.flowToPrice(param * this.ladderPriceRecent.paras["mainPlanLadder" +
                        index + "Price"], index - 1, this.ladderPriceRecent.paras["mainPlanLadder" + index +
                        "Price"]) - totalRecordMoneyParam * 100) / 100;
                    this.workingFlowRankPricePresent = this.ladderPriceRecent.paras["mainPlanLadder" + index + "Price"] / 100;
                    this.workingFlowRankRemain = rankFlow - param;
                }
            },
            flowToPrice(price, n, priceRank) {
                if (n > 0) {
                    price = price - this.ladderPriceRecent.paras["mainPlanLadder" + n + "Flow"] * (priceRank - this.ladderPriceRecent
                        .paras["mainPlanLadder" + n + "Price"]);
                    n--;
                    return this.flowToPrice(price, n, priceRank);
                } else {
                    return price;
                }
            },
            doRecharge() {
                //充值
                var that = this;
                that.isButtonLoading = true;
                this.doRechargeData["recordRechargeMeterId"] = this.deviceTemp.meterId; //设备表号
                if (this.isFlow) {
                    this.doRechargeData["recordRechargePrice"] = this.workingFlowRechargeMoney; //充值金额
                    this.doRechargeData["recordRechargeFlow"] = this.workingFlowRecharge; //充值流量
                } else {
                    this.doRechargeData["recordRechargePrice"] = this.workingMoneyRecharge; //充值金额
                }

                this.doRechargeData["recordRechargePayType"] = this.rechargeBaseInfo.meterTypePayType; //缴费类型
                this.doRechargeData["recordRechargeDate"] = new Date().getTime(); //充值时间
                this.doRechargeData["recordRechargePresentLadderPrice"] = this.workingFlowRankPricePresent; //当前阶梯气价
                this.doRechargeData["recordRechargePresentLadderFlowRemain"] = this.workingFlowRankRemain; //当前阶梯剩余流量
                this.doRechargeData["recordRechargeLadderPriceCopy"] = JSON.stringify(this.ladderPriceRecent); //阶梯气价备份
                this.doRechargeData["recordRechargeAddressName"] = this.rechargeBaseInfo.addressLowestLevelAddressIds; //地址
                this.doRechargeData["recordRechargeCustomerId"] = this.rechargeBaseInfo.customerId; //用户ID
                this.doRechargeData["recordRechargeCustomerName"] = this.rechargeBaseInfo.customerName; //用户姓名
                this.doRechargeData["recordRechargeCustomerIdcard"] = this.rechargeBaseInfo.customerIdcard; //用户身份证

                $.ajax({
                    url: "/api/recharge/doRecharge",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(
                        that.doRechargeData
                    ),
                    dataType: "json",
                    success: function(data) {
                        that.setMeter(that.deviceTemp.meterId);//刷新
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isButtonLoading = false;
                    }
                });
            },
            showModal() {
                this.pay();
            },
            commitRecharge() {
                if (Object.keys(this.ladderPriceRecent.paras) == 0) {
                    this.$Notice.error({
                        title: "异常",
                        desc: "表具未绑定阶梯气价请前往营业厅充值！"
                    });
                } else if (this.workingFlowRecharge * 1 == 0 && this.workingMoneyRecharge * 1 == 0) {
                    this.$Notice.error({
                        title: "异常",
                        desc: "未充值！"
                    });
                } else {
                    this.showModal();
                }
            },
            pay() {
                let that = this;
                // if (that.isFlow) {
                //     that.price = that.workingFlowRechargeMoney; //充值金额
                // } else {
                //     that.price = that.workingMoneyRecharge; //充值金额
                // }
                $.ajax({
                    url: "/api/weChat/payH5",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        meterId: that.meterId,
                        price: that.price //一分钱
                    }),
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.errorCode == 0) {
                            that.appId = receiveData.body.appId;
                            that.timeStamp = receiveData.body.timeStamp;
                            that.nonceStr = receiveData.body.nonceStr;
                            that._package = receiveData.body.package;
                            that.signature = receiveData.body.sign;
                            that.signType = receiveData.body.signType;
                            that.wxPay();
                        } else {
                            that.$Notice.error({
                                title: "异常",
                                desc: receiveData.errorInfo
                            });
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isLoadingButton = false;
                    }
                });
            },
            wxPay() {
                let that = this;
                wx.config({
                    debug: false, // 开启调试模式，关闭
                    appId: that.appId, // 必填，公众号的唯一标识
                    timestamp: that.timeStamp, // 必填，生成签名的时间戳
                    nonceStr: that.nonceStr, // 必填，生成签名的随机串
                    signature: that.signature, // 必填，签名
                    jsApiList: ["chooseWXPay"] // 需要使用的jsapi列表
                });
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
                //config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，
                //则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，
                //则可以直接调用，不需要放在ready函数中。
                wx.ready(function() {
                    wx.checkJsApi({
                        jsApiList: ['chooseWXPay'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                        success: function(res) {
                            // 以键值对的形式返回，可用的api值true，不可用为false
                            // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                            wx.chooseWXPay({
                                timestamp: that.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                                nonceStr: that.nonceStr, // 支付签名随机串，不长于 32 位
                                package: that._package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                                signType: that.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                                paySign: that.signature, // 支付签名
                                success: function(res) {
                                    // 支付成功后的回调函数
                                    alert("支付成功!");
                                    that.doRecharge();
                                },
                                fail: function(res) {
                                    //接口调用失败时执行的回调函数。
                                    alert("接口调用失败!");
                                },
                                cancel: function(res) {
                                    //用户点击取消时的回调函数，仅部分有用户取消操作的api才会用到。
                                    alert("已取消支付！");
                                },
                                complete: function() {}
                            });
                        },
                        fail: function(res) {
                            //接口调用失败时执行的回调函数。
                            alert("浏览器不支持微信支付!");
                        },
                        complete: function() {}
                    });
                });
                wx.error(function(res) {
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，
                    //具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，
                    //对于SPA可以在这里更新签名。
                });
            }
        }

    }
</script>
<style>
</style>
